import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/octavia-combi-2017/comfort",
  "description": "Система адаптивного круиз-контроля (ACC), парковочный автопилот, камера заднего вида с омывателем и многие другие системы в универсале ŠKODA OCTAVIA COMBI.",
  "huggerTemplate": "default",
  "keywords": "Octavia Combi Comfort",
  "name": "octavia-combi comfort",
  "title": "Комфорт ŠKODA OCTAVIA COMBI | Системы помощи водителю в Шкода Октавия Комби"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const QueriedGallery = makeShortcode("QueriedGallery");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" src="/m/octavia-combi-comfort-mainstage2.jpg" mobileSrc="/m/octavia-combi-comfort-mainstage2-mobile.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">НА ВЫСШЕМ УРОВНЕ</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">КОМФОРТ</DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="6" type="modal" tags="octavia-combi comfort" mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Безопасная и лёгкая парковка</DefaultSectionHeading>
  <FeaturesSliderQueried tags="octavia-combi comfortpage-parking" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <ShowRoomTextBlock desktopPic="/m/octavia-combi-comfort-bigstage.jpg" mobilePic="/m/octavia-combi-comfort-bigstage-mobile.jpg" model="octavia-combi" mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle">Адаптивный круиз-контроль</ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" mdxType="ShowRoomTextBlockText">
   Система адаптивного круиз-контроля (ACC) поддерживает заданную водителем скорость с учётом реальной дорожной обстановки, ускоряясь и замедляясь, вплоть до полной остановки, в автоматическом режиме. Основа системы — радар, установленный в передней части автомобиля. Адаптивный круиз-контроль дает возможность проехать по оживленной автомагистрали несколько сотен километров, не прикасаясь к педалям тормоза и газа. Минимальная скорость, поддерживаемая системой, составляет 30 км/ч. Максимальная — 210 км/ч.
  </ShowRoomTextBlockText>
    </ShowRoomTextBlock>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      